import AllRewardsContainer from './AllRewardsContainer';

export default AllRewardsContainer;
